module.exports = __webpack_public_path__ + "statics/img/cate2-3@2x.0eb61f84.png";